import { TestState, TestTypes } from '../actions/tests/tests.d';
import {
  FETCH_TESTS_COMPLETED,
  FETCH_TESTS_ERROR,
  FETCH_TESTS_STARTED,
  UPDATE_TESTS_CURRENT_PAGE,
  UPDATE_TESTS_PAGE_SIZE,
  ADD_TEST_SEARCH,
  CLEAR_TEST_SEARCH,
  UPDATE_TEST_COLUMN_SORT,
  CLEAR_TEST_COLUMN_SORT,
} from 'redux/actionTypes/tests';

const INITIAL_STATE: TestState = {
  data: [],
  error: false,
  submitted: false,
  pagination: {
    totalCount: 0,
    currentPage: 1,
    perPage: 10,
    totalPages: 0,
    nextPage: 0,
    prevPage: null,
    isFirstPage: false,
    isLastPage: false,
    startAt: null,
    endAt: null,
  },
  q: '',
  sorted: [],
};

function testsReducer(state = INITIAL_STATE, action: TestTypes): TestState {
  switch (action.type) {
    case FETCH_TESTS_STARTED: {
      return {
        ...state,
        submitted: true,
      };
    }

    case FETCH_TESTS_COMPLETED: {
      return {
        ...state,
        ...action.payload,
        submitted: false,
      };
    }

    case FETCH_TESTS_ERROR: {
      return {
        ...state,
        error: true,
        submitted: false,
      };
    }

    case UPDATE_TESTS_CURRENT_PAGE: {
      const pagination = {
        ...state.pagination,
      };
      pagination.currentPage = action.payload;
      return {
        ...state,
        pagination: { ...pagination },
      };
    }

    case UPDATE_TESTS_PAGE_SIZE: {
      const pagination = {
        ...state.pagination,
      };
      pagination.perPage = action.payload;
      return {
        ...state,
        pagination: { ...pagination },
      };
    }

    case ADD_TEST_SEARCH: {
      return {
        ...state,
        q: action.payload,
      };
    }

    case CLEAR_TEST_SEARCH: {
      return {
        ...state,
        q: '',
      };
    }

    case UPDATE_TEST_COLUMN_SORT: {
      return {
        ...state,
        sorted: action.payload,
      };
    }

    case CLEAR_TEST_COLUMN_SORT: {
      return {
        ...state,
        sorted: [],
      };
    }

    default:
      return state;
  }
}

export default testsReducer;
